module.exports = __webpack_public_path__ + "img/img_vision_01.d7c384be.png";